import { useEffect } from "react";
import _ from "lodash";
import { setFromURLObject } from "../../utils/urls";
import { IRoadLayoutConfig, IRoadwayConfig, ILightingClassConfig, ILuminaireLayoutConfig, IOptimizationConfig, IProjectConfig } from "../../types";

type Setter<T> = React.Dispatch<React.SetStateAction<T>>;

/**
 * Hydrates config states from URL params on first mount.
 * No-op when htr_url_statefulurl is absent or false — setFromURLObject guards internally.
 */
const useURLHydration = (
  setRoadLayoutConfig: Setter<IRoadLayoutConfig>,
  setRoadwayConfig: Setter<IRoadwayConfig>,
  setLightingClassConfig: Setter<ILightingClassConfig>,
  setLuminaireLayoutConfig: Setter<ILuminaireLayoutConfig>,
  setOptimizationConfig: Setter<IOptimizationConfig>,
  setProjectConfig: Setter<IProjectConfig>
): void => {
  useEffect(() => {
    setRoadLayoutConfig((prev) => setFromURLObject({ ...prev }));
    setRoadwayConfig((prev) => setFromURLObject({ ...prev }));
    setLightingClassConfig((prev) => setFromURLObject({ ...prev }));
    setLuminaireLayoutConfig((prev) => setFromURLObject({ ...prev }));
    setOptimizationConfig((prev) => setFromURLObject(_.cloneDeep(prev)));
    setProjectConfig((prev) => setFromURLObject({ ...prev }));
  }, []); // eslint-disable-line react-hooks/exhaustive-deps
};

export default useURLHydration;
